import { AnySchema } from 'yup'

import CollectionSection from '../components/collection-section'
import { SectionToggle } from '../components/section-heading'
import SharedContactsBanner from './banner'
import { fullName, hasBothNames } from './helpers'
import { Role } from './roles'
import SharedPersonCard, { RenderPersonFields } from './shared-person-card'
import useSharedPeople from './use-shared-people'

type Props = {
  heading: string
  type: string
  addLabel: string
  role: Role
  schema: AnySchema
  toggle?: SectionToggle
  renderFields?: RenderPersonFields
}

/** Taking someone out of this section leaves them on the estate. */
const SharedPeopleSection = ({
  heading,
  type,
  addLabel,
  role,
  schema,
  toggle,
  renderFields,
}: Props) => {
  const { records, hasSharedContacts, people, addDraft, remove, cardProps } =
    useSharedPeople(role)

  return (
    <CollectionSection
      heading={heading}
      type={type}
      records={records}
      getRecordKey={(record) => record.slot}
      onAdd={addDraft}
      addLabel={addLabel}
      onDelete={remove}
      toggle={toggle}
      summary={hasSharedContacts && <SharedContactsBanner />}
      getDeleteConfirmation={(card, cardName) => {
        if (card.isDraft && !card.replaces) return null
        const record = card.replaces
          ? people.find((person) => person.id === card.replaces)
          : card
        if (!record) return null
        if (!hasBothNames(record.attributes))
          return {
            message: `${cardName} will be deleted. This can’t be undone.`,
            confirmButtonText: 'Yes, delete',
            confirmButtonSubmittingText: 'Deleting...',
          }
        return {
          message: `${fullName(record.attributes)} will be removed from this section, and kept as a contact on the estate.`,
          confirmButtonText: 'Yes, remove',
          confirmButtonSubmittingText: 'Removing...',
        }
      }}
      renderRow={(record) => (
        <SharedPersonCard
          // a new form for whoever's in the card, in the same card
          key={record.id}
          schema={schema}
          renderFields={renderFields}
          {...cardProps(record)}
        />
      )}
    />
  )
}

export default SharedPeopleSection
